// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"242":"59c4baf7","504":"449cfbb8","638":"59c4baf7","644":"59c4baf7","651":"59c4baf7","761":"59c4baf7","816":"59c4baf7","836":"59c4baf7","845":"59c4baf7","908":"59c4baf7","957":"58b52e33"}[chunkId] + ".chunk.css";
};